import React from 'react'
import { Info, AlertCircle, CheckCircle, AlertTriangle, Lock, LucideIcon } from 'lucide-react'

interface InfoBoxProps {
 children: React.ReactNode
 variant?: 'info' | 'success' | 'warning' | 'danger' | 'confidential'
 icon?: LucideIcon
 title?: string
 className?: string
}

const variantConfig = {
 info: {
 bg: 'bg-blue-50 dark:bg-blue-900/20',
 border: 'border-blue-200 dark:border-blue-700',
 icon: 'text-blue-600 dark:text-blue-400',
 title: 'text-blue-800 dark:text-blue-200',
 text: 'text-blue-700 dark:text-blue-300',
 defaultIcon: Info
 },
 success: {
 bg: 'bg-green-50 dark:bg-green-900/20',
 border: 'border-green-200 dark:border-green-700',
 icon: 'text-green-600 dark:text-green-400',
 title: 'text-green-800 dark:text-green-200',
 text: 'text-green-700 dark:text-green-300',
 defaultIcon: CheckCircle
 },
 warning: {
 bg: 'bg-yellow-50 dark:bg-yellow-900/20',
 border: 'border-yellow-200 dark:border-yellow-700',
 icon: 'text-yellow-600 dark:text-yellow-400',
 title: 'text-yellow-800 dark:text-yellow-200',
 text: 'text-yellow-700 dark:text-yellow-300',
 defaultIcon: AlertTriangle
 },
 danger: {
 bg: 'bg-red-50 dark:bg-red-900/20',
 border: 'border-red-200 dark:border-red-700',
 icon: 'text-red-600 dark:text-red-400',
 title: 'text-red-800 dark:text-red-200',
 text: 'text-red-700 dark:text-red-300',
 defaultIcon: AlertCircle
 },
 confidential: {
 bg: 'bg-surface',
 border: 'border-border',
 icon: 'text-muted-foreground',
 title: 'text-foreground',
 text: 'text-foreground',
 defaultIcon: Lock
 }
}

export const InfoBox: React.FC<InfoBoxProps> = ({
 children,
 variant = 'info',
 icon,
 title,
 className = ''
}) => {
 const config = variantConfig[variant]
 const Icon = icon || config.defaultIcon

 return (
 <div className={`
 ${config.bg} 
 border ${config.border} 
 rounded-md p-3
 ${className}
 `}>
 <div className="flex items-start space-x-2">
 <Icon className={`h-4 w-4 ${config.icon} mt-0.5 flex-shrink-0`} />
 <div className="flex-1">
 {title && (
 <p className={`text-xs font-semibold ${config.title} mb-1`}>
 {title}
 </p>
 )}
 <div className={`text-xs ${config.text} leading-relaxed`}>
 {children}
 </div>
 </div>
 </div>
 </div>
 )
}

